<template>
  <div class="p-fluid p-formgrid p-grid">

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Na perda do D.S.R. descontar</h6>
      <div class="p-field-radiobutton">
        <RadioButton id="perdaDSRDesconta1" name="perdaDSRDesconta" v-model.number="politicaDSR.perdaDSRDesconta" :value="1"/>
        <label>No mesmo mês</label>
      </div>
      <!-- <div class="p-field-radiobutton">
        <RadioButton id="perdaDSRDesconta1" name="perdaDSRDesconta" v-model.number="politicaDSR.perdaDSRDesconta" :value="2"/>
        <label>No mês posterior</label>
      </div> -->
    </div>    

    <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Pagar D.S.R. </h6>
      <div class="p-field-radiobutton">
        <RadioButton id="pagarDSR1" name="pagarDSR" v-model.number="politicaDSR.pagarDSR" :value="1"/>
        <label>Domingos</label>
      </div>
      <div class="p-field-radiobutton">
        <RadioButton id="pagarDSR2" name="pagarDSR" v-model.number="politicaDSR.pagarDSR" :value="2"/>
        <label>Folgas</label>
      </div>      
    </div>

    <!-- <div class="p-field p-col-12 p-md-12">
      <h6 class="p-text-bold">Na falta, descontar D.S.R.</h6>
      <div class="p-field-radiobutton">
        <RadioButton id="descontoDSR1" name="descontoDSR" v-model.number="politicaDSR.descontoDSR" :value="1"/>
        <label>Domingo</label>
      </div>
      <div class="p-field-radiobutton">
        <RadioButton id="descontoDSR2" name="descontoDSR" v-model.number="politicaDSR.descontoDSR" :value="2"/>
        <label>Feriado e Domingo</label>
      </div>      
    </div>  -->   

  </div>
</template>

<script>
import PoliticaDSR from '@/model/PoliticaDSR';

export default {
  data() {
    return {
      politicaDSR: new PoliticaDSR(),
    }
  },
  methods: {
    setConfiguracao(politicaDSR) {
      this.politicaDSR = politicaDSR;
    },
    getConfiguracao() {
      return this.politicaDSR;
    }
  },
  created() {
    this.politicaDSR.perdaDSRDesconta = 1;
    this.politicaDSR.pagarDSR = 1;
    this.politicaDSR.descontoDSR = 1;   
  }

}
</script>

<style>

</style>